import { isDevFeatureEnabled } from '../../../constants/dev';
import { OrganizationGroup } from '../../../types/organizationGroup';
import { State } from '../../../types/state';
import { resolveDashboardRefreshInterval } from './dashboardRefreshInterval';

export const organizationGroupSelector = (
  state: State
): OrganizationGroup | undefined => state.organizationGroup?.current;

export const emailChatCompletionsEnabledSelector = (state: State) =>
  state.organizationGroup.current?.features?.emailChatCompletions?.enabled;

export const auroraEngineConfigEnabledSelector = (state: State) =>
  !!state.organizationGroup.current?.features?.auroraEngineConfig?.enabled;

export const restrictedEngineCreationEnabledSelector = (state: State) =>
  !!state.organizationGroup.current?.features?.restrictedEngineCreation
    ?.enabled;

export const restrictedEngineEditEnabledSelector = (state: State) =>
  !!state.organizationGroup.current?.features?.restrictedEngineEdit?.enabled;

export const auroraEngineEnabledSelector = (state: State) =>
  !!state.organizationGroup.current?.features?.auroraEngine?.enabled;

export const datasetsFeatureSelector = (state: State) =>
  Boolean(state.organizationGroup.current?.features?.datasets?.enabled);

export const reasoningFieldsEnabledSelector = (state: State) => {
  const reasoningFields =
    state.organizationGroup.current?.features?.reasoningFields;

  if (!reasoningFields?.enabled) {
    return false;
  }

  const { organizationsFilter } = reasoningFields;

  if (!organizationsFilter) {
    return true;
  }

  const currentOrganizationId = state.organization.id;

  return (
    currentOrganizationId !== undefined &&
    organizationsFilter.includes(currentOrganizationId)
  );
};

export const lookupFieldsEnabledSelector = (state: State) =>
  Boolean(state.organizationGroup.current?.features?.lookupFields?.enabled);

export const memoryFieldsEnabledSelector = (state: State) =>
  Boolean(state.organizationGroup.current?.features?.memoryFields?.enabled);

export const customRelationsEnabledSelector = (state: State) =>
  Boolean(state.organizationGroup.current?.features?.customRelations?.enabled);

export const hookInterfacesEnabledSelector = (state: State) =>
  Boolean(state.organizationGroup.current?.features?.hookInterfaces?.enabled);

export const externalStoresEnabledSelector = (state: State) =>
  hookInterfacesEnabledSelector(state) &&
  !!isDevFeatureEnabled('external-stores');

export const prevalidateAnnotationsEnabledSelector = (state: State) =>
  Boolean(
    state.organizationGroup?.current?.features?.prevalidateAnnotations?.enabled
  );

export const configurationHistoryEnabledSelector = (state: State) =>
  Boolean(
    state.organizationGroup?.current?.features?.configurationHistory?.enabled
  );

export const documentHistoryEnabledSelector = (state: State) =>
  Boolean(state.organizationGroup?.current?.features?.documentHistory?.enabled);

export const reautomateEnabledSelector = (state: State) =>
  Boolean(state.organizationGroup?.current?.features?.reautomate?.enabled);

export const additionalLocalesEnabledSelector = (state: State) =>
  Boolean(
    state.organizationGroup?.current?.features?.additionalLocales?.enabled
  );

const aiFeaturesDisabledSelector = (state: State) =>
  Boolean(
    state.organizationGroup?.current?.features?.disableAiFeatures?.enabled
  );

export const aiFeaturesEnabledSelector = (state: State) =>
  !aiFeaturesDisabledSelector(state);

export const dashboardRefreshIntervalSelector = (state: State) =>
  resolveDashboardRefreshInterval(
    state.organizationGroup.current?.features?.dashboardRefresh
  );
